import React, { FC } from "react";
import { CtaSection } from "@/components/CtaSection";
import blog_cta_cover from "@/assets/blog-cta-cover.jpg";

export const BlogCta: FC = () => (
    <CtaSection
      title="Discover 10 Speed"
      paragraph="Explore unique features and capabilities of 10 Speed"
      cta={{
        label: "Product features",
        to: "/#features"
      }}
      backgroundImage={{
        alt: "10 Speed",
        src: blog_cta_cover
      }}
    />
  );
